/* Magic Hits — comanda în pași din pagina de produs (fără Globo): produsul de bază + suplimente, direct la plată. */
(function () {
  'use strict';
  var C = window.MHC, root = document.querySelector('[data-mhc]');
  if (!C || !root) return;
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var lei = function (cents) { var v = (cents / 100).toFixed(2).replace('.', ','); return (v.slice(-3) === ',00' ? v.slice(0, -3) : v) + ' lei'; };
  var first = function (g) { var b = $('[data-g="' + g + '"] [data-v]'); return b ? b.dataset.v : ''; };
  var STEPS = 4, card = $('[data-card]');

  /* urmărirea pașilor (aceeași adresă ca până acum); ?nt=1 scoate browserul din numărătoare */
  var track = (function () {
    var url = C.track, visit = '', off = false, sent = {};
    try {
      if (/[?&]nt=1/.test(location.search)) localStorage.setItem('mh_nt', '1');
      off = localStorage.getItem('mh_nt') === '1';
      visit = sessionStorage.getItem('mh_v') || '';
      if (!visit) { visit = Math.random().toString(36).slice(2, 12) + Date.now().toString(36); sessionStorage.setItem('mh_v', visit); }
    } catch (e) { visit = Math.random().toString(36).slice(2, 12) + Date.now().toString(36); }
    var from = (/[?&]utm_source=([^&]+)/.exec(location.search) || [])[1] || (document.referrer ? document.referrer.split('/')[2] : 'direct');
    return function (event, data, once) {
      if (!url || off || C.preview || !navigator.sendBeacon) return;
      var key = event + ':' + (once || '');
      if (once && sent[key]) return;
      sent[key] = true;
      var body = { v: visit, e: event, d: window.innerWidth < 768 ? 'm' : 'd', r: String(from).slice(0, 20), pg: location.pathname };
      for (var k in data || {}) body[k] = data[k];
      try { navigator.sendBeacon(url, JSON.stringify(body)); } catch (e) {}
    };
  })();

  /* ------------------------------------------------------------ starea */
  var KEY = 'mh_comanda_pasi';
  var S = { step: 1, nume: '', relatie: '', relatie_alt: '', ocazie: '', poveste: '', fraza_on: '', fraza: '', semn_on: '', semnatura: '', stil: first('stil'), emotie: first('emotie'), voce: first('voce'), lungime: '2', streaming: '', livrare: '72', telefon: '' };
  try { var old = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (old) for (var k in S) if (old[k] != null) S[k] = old[k]; } catch (e) {}
  var save = function () { try { sessionStorage.setItem(KEY, JSON.stringify(S)); } catch (e) {} };

  /* 72 de ore = 3 zile lucrătoare; 48 și 24 = ore pe ceas */
  function dateFor(hours) {
    var d = new Date();
    if (hours >= 72) { var days = 3; while (days > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) days--; } }
    else d = new Date(d.getTime() + hours * 3600 * 1000);
    var txt = d.toLocaleDateString('ro-RO', { weekday: 'long', day: 'numeric', month: 'long' });
    return hours <= 24 ? 'mâine, ' + txt.split(', ').pop() : txt;
  }
  function validPhone(raw) {
    var d = String(raw).replace(/[^\d+]/g, '').replace(/^00/, '+');
    return /^(\+?40|0)?7\d{8}$/.test(d) || /^\+(?!40)\d{9,15}$/.test(d);
  }

  var LUNGIME = { 2: '2 Strofe (inclus in pret)', 3: '3 Strofe', 4: '4 Strofe' };
  var LIVRARE = { 72: 'Livrare Standard – 3 zile lucrătoare', 48: 'Livrare Premium – în 48h', 24: 'Livrare Prioritară Absolută – sub 24h' };
  var NUME = { fraza: 'Frază personalizată', nume: 'Numele tău în cântec', s3: '3 strofe', s4: '4 strofe', streaming: 'Publicare pe SoundCloud', d48: 'Livrare în 48 de ore', d24: 'Livrare în 24 de ore' };

  function chosen() {
    var keys = [];
    if (S.fraza_on) keys.push('fraza');
    if (S.semn_on) keys.push('nume');
    if (S.lungime === '3') keys.push('s3');
    if (S.lungime === '4') keys.push('s4');
    if (S.streaming) keys.push('streaming');
    if (S.livrare === '48') keys.push('d48');
    if (S.livrare === '24') keys.push('d24');
    return keys.filter(function (k) { return C.addons[k] && C.addons[k].variant; });
  }
  function total() { return chosen().reduce(function (t, k) { return t + (C.addons[k].price || 0); }, C.main.price || 0); }
  var relatie = function () { return S.relatie === 'alt' ? S.relatie_alt.trim() : S.relatie; };

  /* ------------------------------------------------------------ desenarea */
  var lastTotal = null;
  function paint() {
    $$('.mhc-step').forEach(function (el) { el.hidden = +el.dataset.step !== S.step; });
    $$('.mhc-prog li').forEach(function (li) {
      var n = +li.dataset.p;
      li.classList.toggle('is-now', n === S.step);
      li.classList.toggle('is-done', n < S.step);
      li.firstElementChild.setAttribute('aria-current', n === S.step ? 'step' : 'false');
    });
    $$('[data-f]').forEach(function (el) { if (el.value !== S[el.dataset.f]) el.value = S[el.dataset.f]; });
    $$('[data-g]').forEach(function (g) { $$('[data-v]', g).forEach(function (c) { c.setAttribute('aria-pressed', c.dataset.v === S[g.dataset.g] ? 'true' : 'false'); }); });
    $$('[data-r]').forEach(function (g) { $$('.mhc-opt', g).forEach(function (c) { c.setAttribute('aria-pressed', c.dataset.v === S[g.dataset.r] ? 'true' : 'false'); }); });
    $$('[data-t]').forEach(function (c) { c.checked = !!S[c.dataset.t]; c.closest('.mhc-add').classList.toggle('is-on', c.checked); });
    $$('[data-show]').forEach(function (el) { var p = el.dataset.show.split('='); el.hidden = p[1] ? S[p[0]] !== p[1] : !S[p[0]]; });
    /* un supliment fără produs ales în editor nu se arată deloc */
    $$('[data-addon]').forEach(function (el) { var a = C.addons[el.dataset.addon]; el.hidden = !(a && a.variant); });
    $$('[data-price]').forEach(function (el) { var a = C.addons[el.dataset.price]; el.textContent = a && a.price ? '+' + lei(a.price) : ''; });
    $$('[data-date]').forEach(function (el) { el.textContent = 'o ai până ' + dateFor(+el.dataset.date); });

    /* numele persoanei apare în întrebările următoare */
    var name = S.nume.trim();
    $$('[data-name-for]').forEach(function (el) { el.textContent = name ? 'pentru ' + name : ''; });
    var ticket = $('[data-ticket]'), bits = [];
    if (name) bits.push('Pentru ' + name);
    if (S.step > 3) { bits.push(S.stil.replace(/!$/, '')); if (S.emotie) bits.push(S.emotie); }
    ticket.hidden = S.step === 1 || !bits.length;
    ticket.textContent = '🎵 ' + bits.join(' · ');

    /* povestea: cât a scris și cât mai e bine să scrie */
    var len = S.poveste.trim().length, meter = $('.mhc-meter');
    $('[data-meter]').style.width = Math.min(100, Math.round(len / 1.6)) + '%';
    meter.classList.toggle('is-good', len >= 160);
    $('[data-meter-text]').textContent = len === 0 ? 'Opțional, dar cu cât ne spui mai mult, cu atât e mai a voastră' : len < 160 ? 'Bun început. Cu cât ne spui mai mult, cu atât e mai a voastră.' : 'Perfect, avem din ce face versurile ✓';

    $('[data-phone-ok]').hidden = !validPhone(S.telefon);

    var rows = [['Melodie personalizată' + (name ? ' pentru ' + esc(name) : ''), lei(C.main.price || 0)]].concat(chosen().map(function (k) { return [NUME[k], '+' + lei(C.addons[k].price)]; }));
    rows.push(['Ajunge pe WhatsApp', 'până ' + dateFor(+S.livrare)]);
    $('[data-sum]').innerHTML = rows.map(function (r) { return '<dt>' + r[0] + '</dt><dd>' + r[1] + '</dd>'; }).join('');

    var t = total();
    $$('[data-total]').forEach(function (el) { el.textContent = lei(t); });
    $('[data-compare]').textContent = C.main.compare > C.main.price && t === C.main.price ? lei(C.main.compare) : '';
    if (lastTotal !== null && lastTotal !== t) { var b = $('.mhc-total b'); b.classList.add('is-bump'); setTimeout(function () { b.classList.remove('is-bump'); }, 700); }
    lastTotal = t;

    var last = S.step === STEPS;
    $('[data-next]').textContent = last ? (C.payCta || 'Comandă') : 'Continuă';
    $('[data-back]').hidden = S.step === 1;
    $('[data-under]').hidden = !last;
  }

  /* ------------------------------------------------------------ verificarea, pas cu pas */
  function missing(step) {
    if (step === 1) {
      if (S.nume.trim().length < 2) return ['Scrie numele persoanei, așa cum îi spui tu.', $('[data-f="nume"]')];
      if (!S.relatie) return ['Alege ce loc ocupă în viața ta.', $('[data-g="relatie"]')];
      if (S.relatie === 'alt' && !S.relatie_alt.trim()) return ['Scrie cine este persoana.', $('[data-f="relatie_alt"]')];
    }
    if (step === 2) {
      if (S.fraza_on && !S.fraza.trim()) return ['Scrie fraza pe care o vrei în cântec sau scoate bifa.', $('[data-f="fraza"]')];
      if (S.semn_on && !S.semnatura.trim()) return ['Scrie numele tău sau scoate bifa.', $('[data-f="semnatura"]')];
    }
    if (step === 3 && !S.emotie) return ['Alege ce emoție să transmită melodia.', $('[data-g="emotie"]')];
    if (step === 4 && !validPhone(S.telefon)) return ['Scrie un număr de mobil valid, de exemplu 0751 234 567. Pe el trimitem melodia.', $('[data-f="telefon"]')];
    return null;
  }
  function clearError() {
    $('[data-err]').textContent = '';
    $$('.is-bad').forEach(function (el) { el.classList.remove('is-bad'); });
  }
  function showError(m, step) {
    clearError();
    if (!m) return;
    $('[data-err]').textContent = m[0];
    m[1].classList.add('is-bad');
    m[1].scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (/INPUT|TEXTAREA/.test(m[1].tagName)) setTimeout(function () { m[1].focus({ preventScroll: true }); }, 350);
    track('error', { s: step }, step);
  }
  function go(step, back) {
    S.step = Math.max(1, Math.min(STEPS, step));
    root.classList.toggle('is-back', !!back);
    clearError(); save(); paint();
    if (S.step > 1) track('step', { s: S.step }, S.step);
    card.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function next() {
    var m = missing(S.step);
    showError(m, S.step);
    if (m) return;
    if (S.step < STEPS) return go(S.step + 1);
    submit();
  }

  function submit() {
    /* aceleași denumiri ca în comenzile venite prin Globo, ca echipa să le citească la fel */
    var props = { 'Numele persoanei norocoase': S.nume.trim(), 'Relatie cu persoana': relatie(), 'Ocazie specială?': S.ocazie ? 'Da - pentru o ocazie specială' : 'Nu' };
    if (S.ocazie) props['Momentul special?'] = S.ocazie;
    if (S.poveste.trim()) props['Povestea'] = S.poveste.trim();
    if (S.fraza_on) props['Fraza personalizata'] = S.fraza.trim();
    if (S.semn_on) { props['Mentionare Nume'] = 'Da - vreau să apar și numele meu în cântec'; props['Numele tau'] = S.semnatura.trim(); }
    props['Stil Muzical'] = S.stil; props['Emotia Transmisa'] = S.emotie; props['Vocea dorita'] = S.voce;
    props['Lungime'] = LUNGIME[S.lungime];
    props['Publicare streaming'] = S.streaming ? 'Da – Vreau să fie disponibilă public' : 'Nu – Fișierul MP3 este suficient pentru mine';
    props['Livrare'] = LIVRARE[S.livrare];
    props['Numar telefon'] = S.telefon.trim();
    var items = [{ id: C.main.variant, quantity: 1, properties: props }].concat(chosen().map(function (k) { return { id: C.addons[k].variant, quantity: 1 }; }));
    track('pay', { p: 'Comandă ' + lei(total()) }, 'o data');

    var btn = $('[data-next]');
    if (C.preview || !C.main.variant) {
      var box = $('[data-debug]');
      box.hidden = false;
      box.innerHTML = '<b>Previzualizare: aici, pe site, se deschide pagina de plată (' + lei(total()) + ').</b>În comandă ar intra:<ul>' +
        ['Melodie personalizată'].concat(chosen().map(function (k) { return NUME[k]; })).map(function (n) { return '<li>' + n + '</li>'; }).join('') + '</ul>' +
        'Iar echipa ar vedea:<ul>' + Object.keys(props).map(function (k) { return '<li>' + esc(k) + ': ' + esc(props[k]) + '</li>'; }).join('') + '</ul>';
      box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      return;
    }
    btn.disabled = true; btn.textContent = 'Se pregătește comanda…';
    fetch(C.root + 'cart/clear.js', { method: 'POST' })
      .then(function () { return fetch(C.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) }); })
      .then(function (r) { if (!r.ok) throw new Error('cart'); try { sessionStorage.removeItem(KEY); } catch (e) {} window.location.href = C.root + 'checkout'; })
      .catch(function () { btn.disabled = false; paint(); $('[data-err]').textContent = 'Nu am putut trimite comanda. Mai încearcă o dată sau scrie-ne pe WhatsApp.'; });
  }

  /* ------------------------------------------------------------ legături */
  var opened = function () { track('open', { src: 'formular' }, 'o data'); };
  root.addEventListener('input', function (e) {
    var t = e.target;
    if (t.dataset.f) S[t.dataset.f] = t.value;
    else if (t.dataset.t) { S[t.dataset.t] = t.checked ? 'da' : ''; track('pack', { p: t.dataset.t + (t.checked ? ' da' : ' nu') }); }
    else return;
    opened(); clearError(); save(); paint();
    /* la bifarea unui supliment cu text, ducem cursorul în căsuța lui */
    if (t.dataset.t && t.checked) { var box = $('[data-show="' + t.dataset.t + '"] input'); if (box) box.focus(); }
  });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.tagName === 'INPUT' && e.target.type !== 'checkbox') { e.preventDefault(); e.target.blur(); if (S.step === STEPS || e.target.dataset.f !== 'nume') next(); }
  });
  root.addEventListener('click', function (e) {
    var t = e.target, pick = t.closest('[data-g] [data-v]'), opt = t.closest('.mhc-opt'), hint = t.closest('[data-hint]'), more = t.closest('[data-more]'), prog = t.closest('.mhc-prog li'), demo = t.closest('[data-demo]');
    if (demo) return play(demo);
    if (t.closest('[data-next]')) return next();
    if (t.closest('[data-back]')) return go(S.step - 1, true);
    if (prog) { if (+prog.dataset.p < S.step) go(+prog.dataset.p, true); return; }
    if (more) { more.parentNode.classList.add('is-all'); return; }
    if (hint) {
      var ta = $('[data-f="poveste"]');
      ta.value = (ta.value.trim() ? ta.value.trim() + '\n' : '') + hint.dataset.hint + ' ';
      S.poveste = ta.value; ta.focus();
    } else if (pick) {
      var g = pick.closest('[data-g]'), key = g.dataset.g;
      S[key] = g.hasAttribute('data-toggle') && S[key] === pick.dataset.v ? '' : pick.dataset.v;
    } else if (opt) { S[opt.parentNode.dataset.r] = opt.dataset.v; track('pack', { p: opt.parentNode.dataset.r + ' ' + opt.dataset.v }); }
    else return;
    opened(); clearError(); save(); paint();
    if (pick && S.relatie === 'alt' && pick.dataset.v === 'alt') $('[data-f="relatie_alt"]').focus();
  });

  /* stilurile: se văd primele câteva, restul la cerere (cel ales rămâne mereu la vedere) */
  $$('.mhc-tiles--more').forEach(function (g) {
    var n = +g.dataset.first || 8;
    $$('[data-v]', g).forEach(function (c, i) { if (i >= n && c.dataset.v !== S[g.dataset.g]) c.classList.add('is-extra'); });
    if (!$('.is-extra', g)) $('[data-more]', g).hidden = true;
  });

  /* exemplele: unul singur cântă, butonul se umple pe măsură ce trece melodia */
  var audio = null, playing = null;
  function play(btn) {
    if (!audio) {
      audio = new Audio();
      audio.addEventListener('play', function () { document.dispatchEvent(new CustomEvent('mh:audio', { detail: audio })); });
      document.addEventListener('mh:audio', function (e) { if (e.detail !== audio && !audio.paused) { audio.pause(); if (playing) playing.classList.remove('is-on'); } });
      audio.addEventListener('timeupdate', function () { if (playing && audio.duration) playing.style.setProperty('--played', (audio.currentTime / audio.duration * 100) + '%'); });
      audio.addEventListener('ended', function () { if (playing) { playing.classList.remove('is-on'); playing.style.setProperty('--played', '0%'); } playing = null; });
    }
    if (playing === btn) { if (audio.paused) { audio.play(); btn.classList.add('is-on'); } else { audio.pause(); btn.classList.remove('is-on'); } return; }
    if (playing) { playing.classList.remove('is-on'); playing.style.setProperty('--played', '0%'); }
    playing = btn; audio.src = btn.dataset.demo; audio.play(); btn.classList.add('is-on');
    track('play', null, 'o data');
  }

  /* bara de jos apare cât timp cardul nu e pe ecran; butoanele din pagină care duceau la formular duc tot la el */
  var bar = $('[data-sticky]');
  if (bar && 'IntersectionObserver' in window) new IntersectionObserver(function (en) { bar.classList.toggle('is-in', !en[0].isIntersecting); }, { rootMargin: '-80px 0px 0px 0px' }).observe(card);
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-go], a[href$="#comanda"], a[href*="/products/piesa-personalizata-unicata"]');
    if (!a || a.closest('.mhc-card')) return;
    e.preventDefault();
    card.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  if (S.step > 1 && missing(1)) S.step = 1;
  paint();
  track('view', null, 'o data');
})();
